import { makeStyles } from "@material-ui/core";
import React from "react";

const useStyles = makeStyles((theme) => ({
  shadow: {
    borderRadius: "9999px",
    backgroundColor: theme.palette.primary.light,
    padding: theme.spacing(1),
  },
  number: {
    ...theme.typography.caption,
    fontWeight: "bolder",
    color: theme.palette.common.white,
    backgroundColor: theme.palette.primary.main,
    border: "10.5px solid",
    borderColor: theme.palette.primary.whisper,
    borderRadius: "50%",
    float: "left",
    display: "inline-block",
    width: 50,
    height: 50,
    fontSize: "1.5em",
    lineHeight: "30px",
    textAlign: "center",
  },
}));
const ConcentricBadge = ({ number, color }) => {
  const classes = useStyles();
  return <div className={classes.number}>{number}</div>;
};

export { ConcentricBadge };
